import styled, { css } from 'styled-components'

import { Color } from 'constants/color'

export const ItemContainer = styled.div`
    display: flex;
    position: relative;
`

export const ItemImageContainer = styled.div`
    position: relative;
    justify-content: center;
    align-items: center;

    height: calc(100vh - 150px);
    overflow: hidden;

    &:hover .expand-icon-container {
        display: flex !important;
    }
`

export const Item = styled.img`
    width: 100%;
    height: 100%;
    margin: auto;
    object-fit: contain;
`

export const MinimizeIcon = styled.img`
    width: 24px;
    height: 24px;
    cursor: pointer;
    filter: brightness(0) invert(1);
    filter: brightness(0);
`

export const SliderContainer = styled.div`
    ${props =>
        props.isPaginationRequired
            ? css`
                  margin: 0 32px;
              `
            : null};

    margin-top: 32px;
`

export const Details = styled.div`
    text-transform: lowercase;
    display: flex;

    background-color: ${Color.transparentBlack};
    color: ${Color.white};
    flex-direction: row;
    padding: 11px 16px;
    border-radius: 4px;
    position: absolute;
    left: 0;
    bottom: 0;
`

export const DetailInfo = styled.span`
    display: block;
    font-size: 12px;
    line-height: 16px;
`

export const ControlContainer = styled.div`
    margin-top: 8px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    justify-content: center;
    align-items: center;
`

export const FallbackContainer = styled(ItemImageContainer)`
    background-color: ${Color.alternateGrey};
    color: ${Color.ohGrey};
    font-weight: 500;
    font-size: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
`
